import React, { useEffect } from "react";
import PopImage from "../components/PopImage";
import {
  Page,
  HeroWrap,
  Label,
  Headline,
  SubtitleRow,
  HeroImage,
  SectionHeader,
  ChallengeSection,
  MetricCard,
  ProcessSection,
  ProcessCol,
  SolutionGrid,
  ResultsSection
} from "../components/CaseStudyLayout";

import bank from "../images/bank.png";
import bank1 from "../images/bank/bank1.png";
import bank4 from "../images/bank/bank4.png";
import bank7 from "../images/bank/bank7.png";
import bank9 from "../images/bank/bank9.png";
import bank10 from "../images/bank/bank10.png";
import bank13 from "../images/bank/bank13.png";
import bank16 from "../images/bank/bank16.png";

const Bank = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page>
      <HeroWrap>
        <Label>USER RESEARCH — FINANCIAL SERVICES</Label>
        <Headline>Bank Prize Draw</Headline>
        <SubtitleRow>
          <p>
            A major UK retail bank was relaunching their Prize Draw concept to drive customer loyalty, engagement, and cross-sell banking products. 
            Our goal was to deeply understand user perceptions and guarantee the relaunch would authentically drive business-aligned behaviors.
          </p>
          <div className="meta">
            <strong>ROLE</strong>
            <span>User Researcher</span>
            <strong>CONTEXT</strong>
            <span>Product Loyalty</span>
          </div>
        </SubtitleRow>
      </HeroWrap>

      <HeroImage>
        <PopImage src={bank} alt="Bank Prize Draw Hero Image" title="Bank Prize Draw" />
      </HeroImage>

      <ChallengeSection>
        <div className="left">
          <h2>The Challenge</h2>
          <p>
            The business wanted to increase product cross-selling without alienating users. The prize draw mechanics needed to seem legitimate, rewarding, and deeply engaging, requiring meticulous qualitative design before massive rollout.
          </p>
          <p>
            We structured hypotheses and concurrently ran deep field interviews across 4 retail branches, alongside quantitative surveys to surface motivators and deterrents.
          </p>
        </div>
        <div className="right">
          <div className="metrics-box">
            <MetricCard>
              <h3>52</h3>
              <span>BRANCH CUSTOMERS INTERVIEWED</span>
              <p style={{fontSize: '0.85rem', opacity: 0.8, marginTop: '10px'}}>3-minute rapid interviews checking draw awareness and sentiment.</p>
            </MetricCard>
            <MetricCard>
              <h3>114</h3>
              <span>INTERNAL COLLEAGUES SURVEYED</span>
              <p style={{fontSize: '0.85rem', opacity: 0.8, marginTop: '10px'}}>To understand staff predictions regarding product adoption.</p>
            </MetricCard>
          </div>
        </div>
      </ChallengeSection>

      <ProcessSection>
        <SectionHeader>
          <h2>The Process</h2>
          <span>PHASE 01 — 03</span>
        </SectionHeader>
        <div className="grid-3">
          <ProcessCol>
            <div className="icon">1</div>
            <h3>Competitor Analysis</h3>
            <p>
              Audited the financial service sector and wider loyalty programs. Discovered that relevant prize payouts (e.g. monetary incentives for banks) and high communication legitimacy build the most trust.
            </p>
            <PopImage src={bank9} alt="Loyalty Research" className="pop-image" title="Bank Prize Draw" />
          </ProcessCol>
          
          <ProcessCol>
            <div className="icon">2</div>
            <h3>Field Research</h3>
            <p>
              I deployed survey scripts and interview grids. Found that extremely low win-chance "super draws" deterred engagement. Many preferred notifications indicating they had simply lost, reinforcing trust.
            </p>
            <PopImage src={bank16} alt="Interview Scripts" className="pop-image" title="Bank Prize Draw" />
          </ProcessCol>

          <ProcessCol>
            <div className="icon">3</div>
            <h3>Lab Usability Testing</h3>
            <p>
              Ran controlled testing with 24 participants across 5 persona groups to test our initial prototype mechanisms, specifically the "countdown timer" UX which ultimately drove huge engagement.
            </p>
            <PopImage src={bank13} alt="Lab Insights" className="pop-image" title="Bank Prize Draw" />
          </ProcessCol>
        </div>
      </ProcessSection>

      <SectionHeader style={{borderBottom: 'none'}}>
        <h2>Research Outputs</h2>
        <span>DELIVERED UX INTELLIGENCE</span>
      </SectionHeader>
      <SolutionGrid>
        <div className="wide pop-image">
          <PopImage src={bank10} alt="Compiled Survey Results" title="Bank Prize Draw" />
        </div>
        <div className="pop-image">
          <PopImage src={bank1} alt="Hypothesis Docs" title="Bank Prize Draw" />
        </div>
        <div className="pop-image">
          <PopImage src={bank4} alt="Sentiment Grids" title="Bank Prize Draw" />
        </div>
      </SolutionGrid>

      <ResultsSection>
        <div className="left">
          <h2>Results & Learnings</h2>
          <p>
            Our rigorous lab and field testing definitively shaped the final prize draw architecture, preventing the business from investing in alienating mechanism paths (like silent super-draws). 
            If continued, I would have pursued scaled A/B quant surveys to form a solid statistical business case post-launch.
          </p>
        </div>
        <div className="metrics-grid">
          <div className="result-stat">
            <h3>24</h3>
            <h4>Lab Personas Tested</h4>
            <p>Rigorous, deep-dive qualitative groups.</p>
          </div>
          <div className="result-stat">
            <h3>x4</h3>
            <h4>Bank Branches</h4>
            <p>Nationwide coverage across divergent customer demographics.</p>
          </div>
        </div>
      </ResultsSection>

    </Page>
  );
};

export default Bank;
